import {
  Placeholder,
  UserRoleAttrubutes,
  FormAttributes,
  Role,
} from './user-role.interface';

/**
 *formPlaceholders it labels placeholder with translation string.
 **/
export const FormPlaceholders: Placeholder = {
  email: 'user-role-form.labels.email',
  findByEmail: 'user-role-form.labels.find_by_email',
  getRole: 'user-role-form.labels.get_role',
  updateRole: 'user-role-form.labels.update_role',
  ct: "user-role-type.labels.ct",
  field: "user-role-type.labels.field",
  corporateUserAlertracker: "user-role-type.labels.corporate-user-alerttracker",
  roles: 'user-role-form.labels.roles',
  selectAll: 'user-roles.labels.select_all',
  blank: 'user-roles.labels.bank',
  submitter: 'user-roles.labels.submitter',
  admin: 'user-roles.labels.admin',
  reviewer: 'user-roles.labels.reviewer',
  approver: 'user-roles.labels.approver',
  opAdmin: 'user-roles.labels.op_admin',
  opRead: 'user-roles.labels.op_read',
  opSuperAdmin: 'user-roles.labels.op_super_admin',
  opAdminRead: 'user-roles.labels.op_admin_read',
  opExternal: 'user-roles.labels.op_external',
  successGetMessage: 'user-role-get-message.success',
  errorGetMessage: 'user-role-get-message.error',
  successUpdateMessage: 'user-role-update-message.success',
  errorUpdateMessage: 'user-role-update-message.error',
  inputRequired: 'user-role-form.message.input_required',
  emailPattern: 'user-role-form.message.email_pattern',
};

/**
 * Default Roles and its placeholders
 **/
export const Roles: Array<Role> = [
  {
    roleName: 'SUBMITTER',
    placeholder: FormPlaceholders.submitter,
  },
  {
    roleName: 'ADMIN',
    placeholder: FormPlaceholders.admin,
  },
  {
    roleName: 'REVIEWER',
    placeholder: FormPlaceholders.reviewer,
  },
  {
    roleName: 'APPROVER',
    placeholder: FormPlaceholders.approver,
  },
  {
    roleName: 'OP_ADMIN',
    placeholder: FormPlaceholders.opAdmin,
  },
  {
    roleName: 'OP_READ',
    placeholder: FormPlaceholders.opRead,
  },
  {
    roleName: 'OP_SUPER_ADMIN',
    placeholder: FormPlaceholders.opSuperAdmin,
  },
  {
    roleName: 'OP_ADMIN_READ',
    placeholder: FormPlaceholders.opAdminRead,
  },
  {
    roleName: 'OP_EXTERNAL',
    placeholder: FormPlaceholders.opExternal,
  }
];

/**
 * Request types on api calls
 **/
export const RequestType = {
  getUserRoles: 'getUserRoles',
  getRoleList: 'getRoleList',
  updateUserRoles: 'updateUserRoles',
  createUserRoles: 'createUserRoles',
  getUserPermissions: 'getUserPermissions',
  updateUserPermissions: 'updateUserPermissions'
};

export const UserTypes = [
 {
  typeName: 'CT',
  typeMapping: 'CT_USR',
  selected: false,
 },
 {
  typeName: 'Field',
  typeMapping: 'FIELD_USR',
  selected: false,
 },
 {
  typeName: 'Corporate User (Alert Tracker)',
  typeMapping: 'CORP_USR',
  selected: false,
 }
];

export const UserRoleObjects = [
  {
    tabName: 'SVPP',
    roles: [
      {
        roleName: 'Submitter',
        roleMapping: 'SUBMITTER',
        selected: false
      },
      {
        roleName: 'Reviewer',
        roleMapping: 'REVIEWER',
        selected: false
      },
      {
        roleName: 'Admin',
        roleMapping: 'ADMIN',
        selected: false
      },
      {
        roleName: 'Approver',
        roleMapping: 'APPROVER',
        selected: false
      },
    ],
    selected: false,
    expanded: false,
    isIndeterminate: false
  },
  {
    tabName: 'User Role',
    roles: [
      {
        roleName: 'Role Mngr',
        roleMapping: 'ROLE_MNGR',
        selected: false
      }
    ],
    selected: false,
    expanded: false,
    isIndeterminate: false
  },
  {
    tabName: 'TST 2.0',
    roles: [
      {
        roleName: 'OP Admin',
        roleMapping: 'OP_ADMIN',
        selected: false
      },
      {
        roleName: 'OP Read',
        roleMapping: 'OP_READ',
        selected: false
      },
      {
        roleName: 'OP Super Admin',
        roleMapping: 'OP_SUPER_ADMIN',
        selected: false
      },
      {
        roleName: 'Super User',
        roleMapping: 'SUPER_USER',
        selected: false
      },
      {
        roleName: 'TCI GR86 Goodwill',
        roleMapping: 'TCI_GR86_GOODWILL',
        selected: false
      },
      {
        roleName: '21MM Admin',
        roleMapping: '21MM_ADMIN',
        selected: false
      },
      {
        roleName: 'Remote Auth',
        roleMapping: 'REMOTE_AUTH',
        selected: false
      },
      {
        roleName: 'LMEX',
        roleMapping: 'LMEX',
        selected: false
      },
      {
        roleName: 'EV Credit Admin',
        roleMapping: 'EV_CREDIT_ADMIN',
        selected: false
      },
      {
        roleName: 'Temp DCM Activation',
        roleMapping: 'TEMP_DCM_ACTIVATION',
        selected: false
      }
    ],
    selected: false,
    expanded: false,
    isIndeterminate: false
  },
  {
    tabName: 'Service Connect',
    roles: [
      {
        roleName: 'All Tabs',
        roleMapping: 'SERVICE_CONNECT_ALL',
        selected: false
      },
      {
        roleName: 'Reports',
        roleMapping: 'SERVICE_CONNECT_REPORTS',
        selected: false
      }
    ],
    selected: false,
    expanded: false,
    isIndeterminate: false
  }
];

export const AllowedUserRoleTabs: Array<string> = ['SVPP', 'User Role', 'TST 2.0', 'Service Connect'];

export const AllowedUserRoleMappings: Array<string> = [
  // SVPP
  'SUBMITTER',
  'REVIEWER',
  'ADMIN',
  'APPROVER',
  // User Role
  'ROLE_MNGR',
  // TST 2.0
  'OP_ADMIN',
  'OP_READ',
  'OP_SUPER_ADMIN',
  'SUPER_USER',
  'TCI_GR86_GOODWILL',
  '21MM_ADMIN',
  'REMOTE_AUTH',
  'LMEX',
  'EV_CREDIT_ADMIN',
  'TEMP_DCM_ACTIVATION',
  // Service Connect
  'SERVICE_CONNECT_ALL',
  'SERVICE_CONNECT_REPORTS',
];

export function buildRoleLabelByMapping(groups: Array<any>): Record<string, string> {
  return groups.reduce(
    (acc, group) => {
      (group.roles || []).forEach((r) => {
        acc[r.roleMapping] = r.roleName;
      });
      return acc;
    },
    {} as Record<string, string>
  );
}

export const AllowedRoleLabelByMapping: Record<string, string> = buildRoleLabelByMapping(UserRoleObjects);
